import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleLanguage, changeSingleLanguageStatus, deleteSingleLanguage, languageList, updateSingleLanguage, translate } from "../apis/apiHandler";

export const language = createAsyncThunk(
    "language/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await languageList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addLanguage = createAsyncThunk(
    "language/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleLanguage(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateLanguage = createAsyncThunk(
    "language/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleLanguage(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteLanguage = createAsyncThunk(
    "language/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleLanguage(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeLanguageStatus = createAsyncThunk(
    "language/changeStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeSingleLanguageStatus(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const translateText = createAsyncThunk(
    "language/translate",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await translate(payload);

            if (response?.code === 200) {
                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    languageList: [],
    addLanguageData: {},
    updateLanguageData: {},
    deleteLanguageData: {},
    changeLanguageStatusData: {},
    error: null,
    success: false,
};

const languageSlice = createSlice({
    name: "language",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(language.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(language.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.languageList = payload;
                state.success = true;
            })
            .addCase(language.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addLanguage.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addLanguage.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addLanguageData = payload;
                state.success = true;
            })
            .addCase(addLanguage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateLanguage.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateLanguage.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateLanguageData = payload;
                state.success = true;
            })
            .addCase(updateLanguage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteLanguage.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteLanguage.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteLanguageData = payload;
                state.success = true;
            })
            .addCase(deleteLanguage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeLanguageStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeLanguageStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeLanguageStatusData = payload;
                state.success = true;
            })
            .addCase(changeLanguageStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(translateText.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(translateText.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeLanguageStatusData = payload;
                state.success = true;
            })
            .addCase(translateText.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default languageSlice.reducer;
